import { inject, InjectionToken } from '@angular/core';
import { DEVICE_OS_COOKIE, DEVICE_OS_QUERY_PARAM } from '../constants/device-os.const';
import { resolveQueryCookieParam } from '../helpers/query-cookie-param/query-cookie-param.helper';
import { CookieFacade } from '../services/cookie/cookie.facade';
import { WINDOW } from './window';

/** Live resolver: call on each AGW request; do not treat inject result as a cached string. */
export type DeviceOsResolver = () => string | null;

export const DEVICE_OS: InjectionToken<DeviceOsResolver> = new InjectionToken<DeviceOsResolver>('Device OS Token', {
  providedIn: 'root',
  factory: (): DeviceOsResolver => {
    const window: Window = inject(WINDOW);
    const cookieFacade: CookieFacade = inject(CookieFacade);

    return (): string | null =>
      resolveQueryCookieParam({
        location: window.location,
        cookieFacade,
        queryParam: DEVICE_OS_QUERY_PARAM,
        cookieName: DEVICE_OS_COOKIE,
        hostname: window.location.hostname,
      });
  },
});
